<template>
  <div
    class="dateGrid"
    @click="clicked"
    @mouseover="hoverOn"
    @mouseleave="hoverOff"
  >
    <!-- Header Row : Date -->
    <div style="grid-row: 1; grid-column: 2;">
      <text-item v-if="show == 'date' || show =='dateTime'" txt="Jour" styles="main-l font-s align-c"/>
    </div>
    <div style="grid-row: 1; grid-column: 4;">
      <text-item  v-if="show == 'date' || show =='dateTime'" txt="Mois" styles="main-l font-s align-c"/>
    </div>
    <div style="grid-row: 1; grid-column: 6;">
      <text-item  v-if="show == 'date' || show =='dateTime'" txt="Année" styles="main-l font-s align-c"/>
    </div>
    <!-- Header Row: Time -->
    <div style="grid-row: 1; grid-column: 8;">
      <text-item v-if="show == 'time' || show =='dateTime'" txt="Heure" styles="main-l font-s align-c"/>
    </div>
    <div style="grid-row: 1; grid-column: 10;">
      <text-item  v-if="show == 'time' || show =='dateTime'" txt="Min" styles="main-l font-s align-c"/>
    </div>

    <!-- Input Row : Calendar Trigger -->
    <template v-if="calendar == true && show != 'time'">
    <label ref="calendar" for="cal" style="grid-row: 2; grid-column: 1;">
      <buttonGroup style="margin-right: 0.4rem;">
        <svg-item icon="calendar" styles="main-l size-m"/>
      </buttonGroup>
      <input type="datetime-local" id="cal" min="1900-01-01" max="2080-12-31" value="2022-08-11" style="visibility: hidden; height: 0rem; width: 0rem; position:absolute;"/>
    </label>
    </template> 

    <!-- Input Row  : Date -->
    <div style="grid-row: 2; grid-column: 2;">
      <inputBox  class="row-stretch" v-if="show == 'date' || show =='dateTime'" style="width: 3rem;">
        <input-line maxlength="2" ref="day" id="day" :content="$gen.label('')" @keydown="$gen.onlyInteger" @keyup="jump"/>
      </inputBox>
    </div>
    <div style="grid-row: 2; grid-column: 3;">   
      <text-item  v-if="show == 'date' || show =='dateTime'" txt="/" styles="main-m" class="pad-m"/>
    </div>
    <div style="grid-row: 2; grid-column: 4;">
      <inputBox  class="row-stretch" v-if="show == 'date' || show =='dateTime'" style="width: 3rem;">
        <input-line maxlength="2"  ref="month" id="month" :content="$gen.label('')" @keydown="$gen.onlyInteger" @keyup="jump"/>
      </inputBox>
    </div>
    <div style="grid-row: 2; grid-column: 5;">    
      <text-item  v-if="show == 'date' || show =='dateTime'" txt="/" styles="main-m" class="pad-m"/>
    </div>
    <div style="grid-row: 2; grid-column: 6;">      
      <inputBox class="row-stretch"  v-if="show == 'date' || show =='dateTime'" style="width: 4rem;">
        <input-line maxlength="4"  ref="year" id="year" :content="$gen.label('')" @keydown="$gen.onlyInteger" @keyup="jump"/>
      </inputBox>
    </div>
    <!-- Input Row  : Time -->    
    <div style="grid-row: 2; grid-column: 7;">         
      <text-item v-if="show =='dateTime'" txt="à" styles="main-m" class="pad-m mleft-10" style="margin-right: 1rem;"/>
    </div>
    <div style="grid-row: 2; grid-column: 8;">         
      <inputBox class="row-stretch" v-if="show == 'time' || show =='dateTime'" style="width: 3rem;">
        <input-line maxlength="2" ref="hour" id="hour" :content="$gen.label('')" @keydown="$gen.onlyInteger" @keyup="jump"/>
      </inputBox>
    </div>
    <div style="grid-row: 2; grid-column: 9;">         
      <text-item v-if="show == 'time' || show =='dateTime'" txt=":" styles="main-m" class="pad-m"/>
    </div>
    <div style="grid-row: 2; grid-column: 10;">         
      <inputBox class="row-stretch" v-if="show == 'time' || show =='dateTime'" style="width: 3rem;">
        <input-line maxlength="2" ref="minute" id="minute" :content="$gen.label('')" @keydown="$gen.onlyInteger" @keyup="jump"/>
      </inputBox>
    </div>
    <!-- Input Row  : Delete -->  
    <template v-if="trash == true">
      <buttonGroup class="mleft-08" style="grid-row: 2; grid-column: 11;">
        <svg-item icon="trash" styles="main-l size-m" style="margin-top: 0.15rem;"/>
      </buttonGroup>
    </template> 
  </div>


  <!-- DateRange -->
  <template v-if="dateRange == true">
  <div class="mtop-40">
    <text-item txt="jusqu'au" styles="main-h font-m"/>
  </div>
  <!-- Input Row -->
  <div class="dateGrid mtop-08">
    <inputBox class="row-stretch" style="width: 3rem;">
      <input-line :content="$gen.label('')" placeholder="JJ"/>
    </inputBox>
    <text-item txt="/" styles="main-m align-center" class="pad-m"/>
    <inputBox class="row-stretch" style="width: 3rem;">
      <input-line :content="$gen.label('')" placeholder="MM"/>
    </inputBox>
    <text-item txt="/" styles="main-m align-center" class="pad-m"/>
    <inputBox class="row-stretch" style="width: 4rem;">
      <input-line :content="$gen.label('')" placeholder="AAAA"/>
    </inputBox>
  </div>
  </template>

  
</template>

<script>
export default {
  name: 'default',
  props : {
    dd: {
      type: String,
      default: ""
    },
    mm: {
      type: String,
      default: ""
    },
    yyyy: {
      type: String,
      default: ""
    },
    content: Object,
    styles: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    trash: {
      type: Boolean,
      default: false
    },
    dateRange: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: true
    },  
    show: {
      type: String,
      default: 'date'
    },       
  },
  emits: ['events'],
  data() {
    return {
      hover: false,
    }
  },
  computed: {
    id() {
      return this.content?.id || ""
    },   
  },
  methods: {
      hoverOn() {
        this.hover = true
        this.$emit('events', 'hoverOn', this.id)
      },
      hoverOff() {
        this.hover = false
        this.$emit('events', 'hoverOff', this.id) 
      },
      clicked() {
        this.$emit('events', 'clicked', this.id)  
      },
      jump(e) {
        var target = e.srcElement || e.target
        // Don't jump if Tab
        var key = e.key
        if (this.$gen.isControlKey(key) && key != 'Backspace') {
          return
        }
        // Jump if maxLength
        var maxLength = parseInt(target.attributes["maxlength"].value, 10)
        var myLength = target.value.length
        if (myLength >= maxLength) {
          if (target.id == 'day') {
            this.$refs.month.$el.focus()
          } else if (target.id == 'month'){
            this.$refs.year.$el.focus()           
          } else if (this.$refs.hour && target.id == 'year'){
            this.$refs.hour.$el.focus()           
          } else if (target.id == 'hour'){
            this.$refs.minute.$el.focus()           
          }
        } else if (key == 'Backspace' && myLength === 0) {
          if (target.id == 'minute') {
            this.$refs.hour.$el.focus()
          } else if (target.id == 'hour'){
            this.$refs.year.$el.focus()           
          } else if (target.id == 'year'){
            this.$refs.month.$el.focus()
          } else if (target.id == 'month'){
            this.$refs.day.$el.focus()           
          }
        }
      }     
  },
  // mounted() {
  //   this.$nextTick(function() {
  //       if (this.$refs.day) {
  //         this.$refs.day.$el.focus()
  //       } else if (this.$refs.hour) {
  //         this.$refs.hour.$el.focus()
  //       }        
  //     })
  // },
}
</script>

<style scoped>
.dateGrid {
  display: grid;
  grid-template-columns: repeat(11, max-content);
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 0.1rem;
}
</style>